import { render } from "./ImageDisplayer.vue?vue&type=template&id=4d3157c3&scoped=true"
import script from "./ImageDisplayer.vue?vue&type=script&lang=ts"
export * from "./ImageDisplayer.vue?vue&type=script&lang=ts"

import "./ImageDisplayer.vue?vue&type=style&index=0&id=4d3157c3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4d3157c3"

export default script